import { ValueGetterParams } from 'ag-grid-community';
import { get } from 'lodash';
import { I4BCellType, I4BColumnConfiguration } from '../configurations';
import { DataLibrary, I4bCellConcept } from '../enums';
import { I4BBasicColumnHeader } from '../headers';
import { HeaderType, I4BColumnHeader } from '../models';
import { BasicColumnOptions, I4BColumnOptions } from '../options';
import { I4BColumn } from './i4b-column';

export class DaliaModeValueColumn implements I4BColumn<I4BBasicColumnHeader, I4BColumnConfiguration, I4BColumnOptions> {
  columnId = 'a014bd54-9fc3-11ec-9da8-1123a40210d0-dalia-mode-value';
  className = DaliaModeValueColumn;

  dataLibs: DataLibrary[] = [DataLibrary.DEVICES];

  header: I4BBasicColumnHeader = new I4BBasicColumnHeader({ type: HeaderType.BASIC, displayName: 'DALIA_MODE_VALUE' });
  configuration: I4BColumnConfiguration = {
    isLink: false,
    position: '',
    id: 'expandedVariables',
    translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.DALIA_MODE_VALUE',
    sortProperty: '',
    concept: I4bCellConcept.DEVICES,
    isDefault: false,
    isConfigurable: true,
    width: 160,
    cell: {
      type: I4BCellType.BASIC
    }
  };
  options: I4BColumnOptions = new BasicColumnOptions({ sortable: true });

  constructor(customHeader?: Partial<I4BColumnHeader>, customConfig?: Partial<I4BColumnConfiguration>, customOptions?: Partial<I4BColumnOptions>) {
    if (customHeader) {
      this.header = new I4BBasicColumnHeader({
        ...this.header,
        ...customHeader
      });
    }
    if (customConfig) {
      this.configuration = {
        ...this.configuration,
        cell: { ...this.configuration.cell, ...customConfig.cell }
      };
    }
    if (customOptions) {
      this.options = { ...this.options, ...customOptions };
    }
    this.configuration.cell.valueGetter = (params: ValueGetterParams) => {
      const expandedVariables = get(params, 'data.expandedVariables');
      const tm = get(expandedVariables, ['tm', 'lastValue', 'value']);
      const fm = get(expandedVariables, ['fm', 'lastValue', 'value']);
      const mm = get(expandedVariables, ['mm', 'lastValue', 'value']);
      if (tm === 1) {
        return 'DEVICES.INFO_PAGE.TOOLBAR.MODE.TM';
      } else if (fm === 1) {
        return 'DEVICES.INFO_PAGE.TOOLBAR.MODE.FM';
      } else if (mm === 1) {
        return 'DEVICES.INFO_PAGE.TOOLBAR.MODE.MM';
      }
      return null;
    };
  }
}
